import {forwardRef} from "react"

const EntranceTextbox=forwardRef(({type,val,placeholder,onChange},ref)=>{
    return(
        <input ref={ref} type={type=="password"?"password":"text"} value={val} placeholder={placeholder} onChange={onChange} className="entrance-box" />
    )
})

export default EntranceTextbox